<div class="welcome-box-container">
  <img [src]="mercuryLogoPath" class="mercury-logo" alt="Mercury Logo" />
  <div class="col-12 p-0 jumbo-medium text-primary welcome-text">
    Welcome to your comprehensive shipping provider
  </div>
  <div class="body-medium text-tertiary desc-text">
    We will help you create a profile in just minutes
  </div>
  <div class="subtitle-large text-secondary second-title">
    Build Your Profile
    <ul class="body-large text-tertiary second-description">
      <li>Confirm company information</li>
      <li>Choose a shipping location</li>
      <li>Add billing information</li>
    </ul>
  </div>
  <button
    pRipple
    pButton
    class="p-button-primary w-full button-text-medium continue"
    autofocus
    (click)="sendToOnboardingForm()"
  >
    <span pButtonLabel>Continue</span>
  </button>
</div>
